<template>
  <v-row
    class="ma-0 pa-0 align-center justify-space-between"
    no-gutters
    style="min-height: 225px"
    v-if="hasAcquisitions"
  >
    <v-col class="mx-2 flex-grow-0 flex-shrink-0">
      <v-radio-group class="my-0" v-model="sort" row>
        <v-radio label="Ascending"></v-radio>
        <v-radio label="Descending"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col class="mx-4 flex-grow-1 flex-shrink-0">
      <v-row class="ma-0 pa-0 align-center flex-grow-1 flex-shrink-0">
        <v-col class="flex-grow-0 flex-shrink-0">
          {{ sort === 0 ? "Oldest" : "Newest" }}
        </v-col>
        <v-col class="mx-2 flex-grow-1 flex-shrink-1">
          <vue-slider
            :enable-cross="false"
            v-model="value"
            :data="sortedAcquisitions"
            :data-value="'id'"
            :data-label="'time'"
            tooltip="always"
            contained="true"
            id="timeline-slider"
          >
            <template v-slot:tooltip="{ value }" style="pointer-events: none">
              <div class="text-center" title="Acquisition ID">
                <div class="text--secondary">Acquisition ID:</div>
                <div class="d-flex align-center">
                  {{ value }}
                </div>
                <div>
                  <v-btn
                    icon
                    x-small
                    @click.prevent="copyToClipboard(value)"
                    title="Copy Acquisition ID"
                    style="pointer-events: all"
                    ><v-icon color="primary">mdi-content-copy</v-icon></v-btn
                  >
                </div>
              </div>
            </template>
            <template v-slot:label="{ label, active }">
              <div :class="['vue-slider-mark-label', { active }]">
                <div class="py-2 text-center" style="cursor: grab">
                  {{ new Date(label).toLocaleString() }}
                  <!--
                  <v-checkbox
                    value
                    label="remove all"
                    dense
                    hide-details
                    style="padding: 0"
                  ></v-checkbox>
                  -->
                </div>
              </div>
            </template>
          </vue-slider>
        </v-col>
        <v-col class="flex-grow-0 flex-shrink-0">
          {{ sort === 0 ? "Newest" : "Oldest" }}
        </v-col>
      </v-row>
    </v-col>
    <v-col
      class="mx-2 d-flex justify-end align-center flex-grow-0 flex-shrink-0"
    >
      <v-btn
        class="ma-4 button_text--text"
        small
        elevation="4"
        color="primary"
        @click="previousPage"
        :disabled="timelinePage <= 1"
        title="Previous page"
      >
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <div class="mx-2">{{ timelinePage }}</div>
      <v-btn
        class="ma-4 button_text--text"
        small
        elevation="4"
        color="primary"
        @click="nextPage"
        :disabled="
          timelinePage >=
          Math.ceil(unique_acquisitions.length / timelineItemsPerPage)
        "
        title="Next page"
      >
        <v-icon> mdi-chevron-right </v-icon>
      </v-btn>
    </v-col>
  </v-row>
  <v-row class="ma-0 pa-0 align-center" no-gutters v-else>
    <v-col class="text-center pa-8">No acquisitions</v-col>
  </v-row>
</template>

<script>
import VueSlider from "vue-slider-component";
import "@/assets/scss/vue-slider-component-theme.scss";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const uiStore = createNamespacedHelpers("ui");

export default {
  props: {
    unique_acquisitions: {
      type: Array,
      required: true,
    },
  },
  components: { VueSlider },
  computed: {
    sortedAcquisitions() {
      if (this.hasAcquisitions) {
        const acquisitions = this.unique_acquisitions;
        const sorted = acquisitions.sort((a, b) => {
          const aDate = new Date(a.time);
          const bDate = new Date(b.time);
          return this.sort === 0 ? aDate - bDate : bDate - aDate;
        });

        const startIndex = (this.timelinePage - 1) * this.timelineItemsPerPage;
        const pagedMatches = sorted.slice(
          startIndex,
          startIndex + this.timelineItemsPerPage
        );
        return pagedMatches;
      }

      return [];
    },
    hasAcquisitions() {
      return (
        this.unique_acquisitions &&
        Array.isArray(this.unique_acquisitions) &&
        this.unique_acquisitions.length > 0
      );
    },
  },
  watch: {
    unique_acquisitions(newVal, oldVal) {
      this.updateTimelineValue();
    },
    value(newVal, oldVal) {
      this.$emit("change", newVal);
    },
  },
  setup() {
    const { SHOW_SNACKBAR } = uiStore.useMutations(["SHOW_SNACKBAR"]);
    return { SHOW_SNACKBAR };
  },
  data() {
    return {
      value: null,
      sort: 1,
      timelinePage: 1,
      timelineItemsPerPage: 6,
    };
  },
  methods: {
    nextPage() {
      this.timelinePage++;
      this.updateTimelineValue();
    },
    previousPage() {
      this.timelinePage--;
      this.updateTimelineValue();
    },
    updateTimelineValue() {
      this.$nextTick(() => {
        this.value =
          this.sortedAcquisitions.length > 0
            ? this.sortedAcquisitions[0].id
            : null;
      });
    },

    copyToClipboard(value) {
      this.clearSelection();
      navigator.clipboard.writeText(value);
      this.SHOW_SNACKBAR({
        text: `Copied ${value} successfully`,
        color: "success",
      });

      this.clearSelection();
    },

    clearSelection() {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          // Chrome
          window.getSelection().empty(); // clear current selection
        } else if (window.getSelection().removeAllRanges) {
          // Firefox
          window.getSelection().removeAllRanges(); // clear current selection
        }
      } else if (document.selection) {
        // IE?
        document.selection.empty(); // clear current selection
      }
    },
  },
};
</script>

<style lang="scss">
#timeline-slider div.vue-slider-dot-tooltip {
  pointer-events: none;
}
</style>
